<template>
  <div
    id="exchange"
    class="exchange-container"
  >
    <div class="agency-part-wrapper content-part-wrapper">
      <div class="agency-title-wrapper content-title-wrapper">
        <h3>{{ $t('Exchange') }} </h3>
        <span class="title-line"></span>
      </div>
      <div class="agency-container">
        <div class="agency-item">
          <div class="agency-img-wray exchange-wrap">
            <a href="https://gateio.news/trade/BXC_USDT" target="_blank">
                <img
                src="../../assets/exchange/gateio.png"
                >
            </a>
          </div>
        </div>

        <div class="agency-item">
          <div class="agency-img-wray exchange-wrap">
            <a href="https://www.coinsuper.info/trade?symbol=BxC%2FUSDT" target="_blank">
                <img
                src="../../assets/exchange/WX20190929-210022@2x.png"
                >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "Exchange": "EXCHANGE"
  },
  "zn": {
    "Exchange": "交易所"  
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
  }),
  created() {
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";
  }
};
</script>

<style scoped lang="stylus">
.agency-part-wrapper {
    .agency-item {
        width: 50%;
    }
    .agency-item .exchange-wrap{
        justify-content: center;
    }

    .agency-container{
        margin: 120px;
    }

    .agency-item{
        argin-bottom: 60px

        img {
            min-width: 240px;
        }
    }

}

.exchange-container{
    margin-top: 200px;
}


</style>


